import React, { useCallback, useContext, useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
import warnOnce from "warn-once";
//#region src/modules/FormBuilder/contexts/FormBuilderFieldsContext.tsx
/**
* This context is used by the Fields components - it should wrap any FormBuilder*Renderer components
* and provide values for the Field components to render.
*/
var FormBuilderFieldsContext = React.createContext(void 0);
var FormBuilderFieldsContextProvider = ({ children, errorsByFieldId = {}, initialValues, onFormValueChange, values }) => {
	const [valuesByFieldId, setValuesByFieldId] = useState(initialValues || {});
	useEffect(() => {
		if (values) setValuesByFieldId(values);
	}, [values]);
	const fieldValueChanged = useCallback((fieldId, value) => {
		setValuesByFieldId((prevState) => {
			if (prevState[fieldId] !== value) return {
				...prevState,
				[fieldId]: value
			};
			return prevState;
		});
	}, []);
	useEffect(() => {
		if (onFormValueChange) onFormValueChange(valuesByFieldId);
	}, [valuesByFieldId]);
	return /* @__PURE__ */ jsx(FormBuilderFieldsContext.Provider, {
		value: {
			errorsByFieldId,
			fieldValueChanged,
			valuesByFieldId
		},
		children
	});
};
var useFormBuilderFieldsContext = () => {
	const ctx = useContext(FormBuilderFieldsContext);
	if (!ctx) {
		warnOnce(true, "<FormBuilderFieldsContextProvider> is required to be a parent when using useFormBuilderFieldsContext()");
		throw new Error("<FormBuilderFieldsContextProvider> is required to be a parent when using useFormBuilderFieldsContext()");
	}
	return ctx;
};
//#endregion
export { FormBuilderFieldsContext, FormBuilderFieldsContextProvider, useFormBuilderFieldsContext };

//# sourceMappingURL=FormBuilderFieldsContext.js.map